import { useAppSelector } from './store';

export default function useCurrentBrand() {
  return useAppSelector((state) => state.tenant.brand);
}
